import { Link, matchRoutes, useLocation } from "react-router-dom";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import { routes } from "@routes/index";
import { BreadcrumbItem } from "@interfaces/Routes";
import { sendEvent } from "@utilities/googleAnalytics";
import { GoogleAnalyticsEvents } from "@constants/googleAnalyticsEvents";

const BreadcrumbsComponent = () => {
    const location = useLocation();
    const matches = matchRoutes(routes, location);

    let breadcrumbs: any = null;
    matches?.forEach((match) => {
        if (location.pathname === match.pathname && match.route.breadcrumbs && match.route.breadcrumbs.length > 0) {
            breadcrumbs = [...match.route.breadcrumbs];
        }
    });

    const leafElement = breadcrumbs?.pop();

    return (
        <Box>
            {breadcrumbs && breadcrumbs?.length >= 0 && (
                <Breadcrumbs separator="/" aria-label="breadcrumb">
                    {breadcrumbs?.map((breadcrumbEntry: any, index: number) => {
                        const breadcrumb = breadcrumbEntry as BreadcrumbItem;
                        return (
                            <Link
                                key={index}
                                onClick={() => {
                                    sendEvent(GoogleAnalyticsEvents.BreadcrumbLink, { text: breadcrumb.text });
                                }}
                                to={breadcrumb.navigate ?? ""}
                                style={{ textDecoration: "none", fontSize: "13px" }}
                            >
                                {breadcrumb.text}
                            </Link>
                        );
                    })}
                    <Typography pt={"2px"} fontSize={13}>
                        {leafElement?.text}
                    </Typography>
                </Breadcrumbs>
            )}
        </Box>
    );
};

export default BreadcrumbsComponent;
